import React from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { GenericTextSearchPanel, TextSearchPanelData } from '../primitives/SearchPanel';
import { DocumentationDocBase } from './useDocumentationPages';

interface Props {
  search: TextSearchPanelData<DocumentationDocBase>;
  routePathPrefix: string;
}

export const DocumentationSearchPanel = (props: Props) => {
  const { search, routePathPrefix } = props;
  const history = useHistory();

  const { formatMessage } = useIntl();

  return (
    <GenericTextSearchPanel
      search={search}
      getItemId={item => item._id}
      getItemLabel={item => item.title}
      onItemSelect={item => {
        const cleanPrefix = routePathPrefix.replace(/\/$/, "");
        history.push(`${cleanPrefix}/${item._id}`)
      }}
      placeholderText={formatMessage({ id: "documentation.search.search_placeholder"})}
      searchingText={formatMessage({ id: "documentation.search.searching"})}
      noResultsText={formatMessage({ id: "documentation.search.no_result"})}
      />
  )
  
};

